require('nanomodal');
window.$ = window.jQuery = require('jquery');
require('slick-carousel');
const mediator = require('./mediator.js');

class Modal {
    constructor(data) {
        this.id = data.id;
        this.content = data.content;

        this.nanoModal = window.nanoModal(" ", { overlayClose: false });
        this.lastSlide = this.content.modal.length - 1;

        this.beforeShow();
        mediator.subscribe('modals:final', () => {
            $(document).off('wheel');
        });
    }
    beforeShow() {
        let element = this.nanoModal.modal;
        
        this.nanoModal.onShow(() => {
            setTimeout(() => {
                this.nanoModal.modal.el.classList.add('fade-in');
            }, 50);
        });
        this.nanoModal.onHide(() => {
            this.nanoModal.modal.el.classList.remove('fade-in');
            this.hide();
        });
        let header = this.content.title;
        let alt = header.split(' ')[0];
        let imageId = this.id;
        let content = this.content.modal.reduce((mem, item) => {
            return mem + `<div><div class="modal__content">${item}</div></div>`;
        }, '');
        // <div class="modal__top"><span class="close"></span><h3>${header}</h3><img src="./img/modal-${imageId}.png" alt="${header}"/></div>
        let html = `<div class="modal__wrapper"><span class="close"></span>
            <h3>${header}</h3><img src="./img/modal-${imageId}.png" alt="${alt}"/>
            <div class="slick-container">${content}</div>
            <div class="modal__label"><span><svg class="icon" width="39.9" height="40"><use xlink:href="#logo-quality" /></svg></span></div>
        </div>`;

        element.html(html);
        this.slick = element.el.getElementsByClassName('slick-container')[0];

        let closes = element.el.getElementsByClassName('close');
        [].forEach.call(closes, item => {
            item.addEventListener('click', event => {
                event.preventDefault();
                mediator.publish('modal:closed', this.id);
                this.hide();
            }, false);
        });
    }
    hide() {
        if ($(this.slick).hasClass('slick-initialized')) {
            $(this.slick).slick('unslick');
        }
        this.nanoModal.hide();
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('show-modal');

        let wheelPause = false;
        let wheelHandler = event => {
            event.preventDefault();
            if (!wheelPause) {
                wheelPause = true;
                setTimeout(() => {
                    wheelPause = false;
                }, 300);

                let delta = event.originalEvent.deltaY;

                if (delta < 0) {
                    mediator.publish('modals:firstscroll', this.id, true);
                } else {
                    mediator.publish('modals:lastscroll', this.id, true);
                }
            }
        };

        $(document).off('wheel');
        $(document).on('wheel', wheelHandler);
    }
    show(scrollDelay) {
        this.beforeShow();
        this.nanoModal.show();
        let body = document.getElementsByTagName('body')[0];
        body.classList.add('show-modal');

        $(this.slick).slick({
            dots: true,
            arrows: false,
            fade: true,
            // vertical: true,
            // verticalSwiping: true,
            infinite: false,
            speed: 0,
            slidesToShow: 1,
            adaptiveHeight: true
        });

        mediator.publish('modal:show', this.id, 1, this.content);


        let wheelPause = false;
        let wheelHandler = event => {
            event.preventDefault();
            if (!wheelPause) {
                wheelPause = true;
                setTimeout(() => {
                    wheelPause = false;
                }, 300);

                let delta = event.originalEvent.deltaY;
                let currentSlide = $(this.slick).slick('slickCurrentSlide');
                mediator.publish('modal:show', this.id, currentSlide + 1, this.content);

                if (delta < 0) {
                    if (currentSlide === 0) {
                        // this.hide();
                        // $(this.nanoModal.overlay.el).off('wheel', wheelHandler);
                        // $(this.nanoModal.modal.el).off('wheel', wheelHandler);
                        mediator.publish('modals:firstscroll', this.id, false);
                    }

                    $(this.slick).slick('slickPrev');
                } else {
                    if (currentSlide === this.lastSlide) {
                        mediator.publish('modals:lastscroll', this.id, false);                            
                    }

                    $(this.slick).slick('slickNext');
                }
            }
        };
        setTimeout(() => {
            // $(this.nanoModal.overlay.el).on('wheel', wheelHandler); 
            // $(this.nanoModal.modal.el).on('wheel', wheelHandler);
            $(document).off('wheel');
            $(document).on('wheel', wheelHandler);
        }, scrollDelay);
    }
}

class Modals {
    constructor(data) {
        this._data = [];

        data.forEach(item => {
            this._data.push(new Modal(item));
        });

        mediator.subscribe('final:show', () => {
            this.hide();
        });
    }
    _find(id) {
        return this._data.find(item => item.id === id);
    }
    hide() {
        this._data.forEach(item => {
            item.hide();
        });
    }
    show(id, scrollDelay) {
        this.hide();

        scrollDelay = scrollDelay || 0;
        let modal = this._find(id);
        if (modal) {
            modal.show(scrollDelay);
        }
    }
}

module.exports = Modals;


// WEBPACK FOOTER //
// ./js/modals.js